import React from 'react';

import { Link } from '@ontruck/orc';
import { compose, withHandlers, withState } from 'recompose';

import includeAnalytics from 'redux/modules/analytics/HOC';

import TooltipStyled from '../styled';
import { injectIntl } from 'react-intl';

const enhance = compose(
  includeAnalytics,
  withState('copied', 'setCopied', false),
  withHandlers({
    sendAnalyticsEvent:
      ({ sendEvent, events }) =>
      (value) => {
        sendEvent(events.COPY_DETAIL, {
          path: window ? window.location.pathname : null,
        });
      },
  }),
  withHandlers({
    handleClick:
      ({ onClick, setCopied, sendAnalyticsEvent }) =>
      () => {
        onClick();
        sendAnalyticsEvent();
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      },
  })
);

const CopyButton = ({ copied, handleClick, intl }) => {
  const t = intl.messages.modules.copy.copyButton;
  return (
    (copied && (
      <TooltipStyled skin={'dark'} position="bottom" component={t.copied} alwaysVisible={copied}>
        <Link skin="secondary" text={t.click} onClick={handleClick} />
      </TooltipStyled>
    )) || <Link skin="secondary" text={t.click} onClick={handleClick} />
  );
};

export default injectIntl(enhance(CopyButton));
